var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCentrifuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16807 15.1518C4.71853 14.1894 4.46744 13.1157 4.46744 11.9835C4.46744 7.84407 7.82307 4.48845 11.9625 4.48845C14.2674 4.48845 16.3291 5.52892 17.704 7.16571L18.5243 6.47746C16.953 4.60683 14.5967 3.41772 11.9625 3.41772C7.23174 3.41772 3.39673 7.25274 3.39673 11.9835C3.39673 13.2775 3.68368 14.5045 4.19744 15.6043L5.16807 15.1518Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9625 17.0693C9.15367 17.0693 6.87663 14.7922 6.87663 11.9834C6.87663 9.17454 9.15367 6.89749 11.9625 6.89749C13.5266 6.89749 14.9254 7.60371 15.8584 8.71439L16.6789 8.02597C15.5495 6.68146 13.8558 5.82678 11.9625 5.82678C8.56232 5.82678 5.80591 8.58319 5.80591 11.9834C5.80591 15.3836 8.56232 18.14 11.9625 18.14V17.0693Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8077 13.5317C13.3658 14.0578 12.7031 14.3923 11.9623 14.3923C10.6318 14.3923 9.5532 13.3137 9.5532 11.9832C9.5532 10.6527 10.6318 9.57407 11.9623 9.57407C12.7031 9.57407 13.3658 9.9086 13.8077 10.4347L14.7304 9.66047C14.0675 8.8713 13.0736 8.36951 11.9623 8.36951C9.96653 8.36951 8.34863 9.9874 8.34863 11.9832C8.34863 13.9789 9.96653 15.5969 11.9623 15.5969C12.9808 15.5969 13.9004 15.1752 14.5573 14.4973L13.8077 13.5317Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentrifuge);
export default __webpack_public_path__ + "static/media/centrifuge.9e0aa7cde2e8b32b5f3d11f5bd320e8e.svg";
export { ForwardRef as ReactComponent };